import { AccountReportGenerator } from './accountReportGenerator';

export { AccountReportGenerator } from './accountReportGenerator';

export const generateAccountReportPDF = async (
  account: any,
  accountType: 'Pagar' | 'Cobrar',
  userName: string,
  imageBase64: string,
) => {
  const generator = new AccountReportGenerator({
    userName,
    imageBase64,
    title: 'Reporte de Cuenta',
    fileName: `CUENTA-${accountType}-${account.folio || account.id}.pdf`,
    account,
    accountType,
  });

  await generator.generate();
};
